import type { Ticket } from 'api';
import { useApiTicketsV1FindList } from 'api';
import React, { useState } from 'react';
import { DataGrid } from 'ui';

import { useFindTicketsFilters } from '../../hooks/useFindTicketsFilters/useFindTicketsFilters';
import { columns } from './columns';

export const FindTicketsTable = () => {
  const permanent_filters = useFindTicketsFilters();
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 25 });

  const params: Record<string, string | number | null> = {
    page: paginationModel.page + 1, // API uses 1-based indexing
    page_size: paginationModel.pageSize,
  };

  permanent_filters.forEach((filter) => {
    if (filter.value != null) {
      params[filter.field] = filter.value;
    }
  });

  const { data, isLoading } = useApiTicketsV1FindList(params);

  return (
    <DataGrid<Ticket>
      loading={isLoading}
      onPaginationModelChange={setPaginationModel}
      paginationMode="server"
      autoHeight
      paginationModel={paginationModel}
      rowCount={data?.count || 0}
      rows={data?.results || []}
      showColumnVerticalBorder
      showCellVerticalBorder
      density="standard"
      sx={{ overflowX: 'scroll' }}
      columns={columns}
      onRowClick={(params) => {
        window.open(params.row.external_link);
      }}
    />
  );
};
